export default __webpack_public_path__ + "static/media/facebookWhite.0db7e21e.svg";